export default "__VITE_ASSET__CN$H1Dlp__"